
import { hasNativeBridge, isMobileOS, detectOS } from "../util/userAgent";
import {
    getDevice as nativeGetDevice,
} from "../common/nativeBridge";
import { callSaveDevice } from '../api/MuyeonApi';

export async function setDeviceInfoSvc(d) {
    //앱으로 접속 일경우 — muyeonClient(로그인 JWT) 로 저장해야 userId 연결됨
    if (hasNativeBridge()){
        const param = {
            deviceOsCd: d?.systemName ?? "",
            deviceId: d?.deviceId ?? "",
            deviceBrand: d?.deviceModel ?? "",
            deviceSystemVer: d?.systemVersion ?? "",
            deviceUniqId: "",
            deviceAppVer: d?.appVersion ?? "",
            deviceToken:d?.deviceToken ?? "",
            osType:detectOS(),
            notiPermissionYn: d?.pushNotificationStatus=="Forever" ? "Y" : "N"
        };
        const res = await callSaveDevice(param);
        return res?.data;
    }
}

export async function getDeviceInfoSvc() {
    //앱으로 접속 일경우
    if (hasNativeBridge()){
        const result = await nativeGetDevice();
        if (result?.status === 200) {
            const d = Array.isArray(result.data) ? result.data[0] : result.data;
            return d;
        }else{
            return null;
        }
    } else{
        return null;
    }
}

